var exports = {
  "om": "xa15a2ab7--47a7cb--block",
  "u1": "xa15a2ab7--47a7cb--spinner",
  "uW": "xa15a2ab7--47a7cb--section",
  "j6": "xa15a2ab7--47a7cb--section-heading",
  "n8": "xa15a2ab7--47a7cb--line",
  "Mj": "xa15a2ab7--47a7cb--line-label",
  "YC": "xa15a2ab7--47a7cb--line-value-link",
};

module.exports = exports;
